import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import Api from "../../services/api";
import { changeIndexToNepali } from "../../utils";
import Actions from "./Actions";
import "./style.css";
import localMapJson from "../../assets/geoJson/province.json";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FaPrint } from "react-icons/fa";
import { BounceLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../assets/images/logo.svg";

const InternalControl = () => {
  const [questionLoading, setQuestionLoading] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [palikaName, setPalikaName] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [totalMarks2, setTotalMarks2] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

  const toogleConfirmation = () => setShowConfirm(!showConfirm);

  let localData = "";
  let localData2 = "";
  let fiscalYear = "";
  let ministryId = "";

  if (JSON.parse(localStorage.getItem("user"))) {
    localData = JSON.parse(localStorage.getItem("user")).user.role_id;
    localData2 = JSON.parse(localStorage.getItem("user")).token;
    fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
    ministryId = JSON.parse(localStorage.getItem("user")).user.ministry_id;
  }

  const user = JSON.parse(localStorage.getItem("user")).user;
  const ministryid = user.ministry_id
    ? user.ministry_id
    : sessionStorage.getItem("m_id");
  const initialCall = useCallback(async () => {
    // console.log("user1", user);
    setQuestionLoading(true);
    let response = await Api.getInternalQuestions(
      fiscalYear,
      sessionStorage.getItem("provinceId"),
      sessionStorage.getItem("m_id")
    );
    if (response && response.code === 200) {
      setQuestionData(response.response);
    }
    setQuestionLoading(false);

    setPalikaName(user.ministry_name);
  }, []);

  const handleSubmit = async () => {
    const reqBody = {
      fiscal_year_id: fiscalYear,
      ministry_id: ministryid,
    };
    const res = await Api.publishInternalAnswer(reqBody);
    if (res && res.code === 200) {
      toast.success("प्रकाशित गर्न सफल ।", {
        position: toast.POSITION.TOP_CENTER,
      });
      toogleConfirmation();
    }
    if (res && res.code === 200) {
      toast.error("सबै आन्तरिक प्रश्नहरूको जवाफ छैन !!!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error("केहि गलत भयो कृपया पुन: प्रयास गर्नुहोस् ।।", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const getTotalMarks = () => {
    let total;
    if (questionData && questionData.length > 0) {
      total = questionData.filter(
        (x) => x.is_existence === true || x.is_existence === false
      ).length;
    }
    return total;
  };

  const getTotalMarks2 = () => {
    let total;
    if (questionData && questionData.length > 0) {
      total = questionData.filter(
        (x) => x.has_continuity === true || x.has_continuity === false
      ).length;
    }
    return total;
  };

  useEffect(() => {
    initialCall();
  }, [initialCall]);

  useEffect(() => {
    setTotalMarks(getTotalMarks());
    setTotalMarks2(getTotalMarks2());
  }, [questionData]);

  const internalControlRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => internalControlRef.current,
  });

  return (
    <>
      {questionLoading ? (
        <div className="w-100 d-flex justify-content-center my-5">
          {" "}
          <BounceLoader color="#1f8cd5" />
        </div>
      ) : (
        <div className="manual-wrapper">
          <div className="mx-1 sticky-heading-internal">
            <h1 className="heading">{user.ministry_name}</h1>{" "}
            <div>
              <Button
                onClick={handlePrint}
                color="success"
                className="print-button"
              >
                <FaPrint className="print-icon" />
                Print
              </Button>
              <Button
                onClick={() => toogleConfirmation()}
                className="uni-menu-item"
              >
                प्रकाशित गर्नुहोस्
              </Button>
            </div>
          </div>

          <div ref={internalControlRef}>
            <div className="print-header print-only-internal">
              <img src={logo} alt="logo" className="nav-logo-user" />
              <div style={{ color: "#e12a2a", marginLeft: 20, fontSize: 14 }}>
                <span style={{ color: "#676767", fontSize: 20 }}>
                  {user.ministry_name} <br />
                </span>
                <span style={{ color: "#2572bc", fontSize: 14 }}>
                  -<br />
                </span>
                PROVINCIAL FIDUCIARY RISK ASSESSMENT
              </div>
            </div>
            <table
              className="waffle"
              cellSpacing={5}
              style={{ borderCollapse: "unset" }}
              cellPadding={10}
              width={"100%"}
            >
              <thead className="table-heading-internal">
                <tr>
                  <td className="font-weight-bold text-right">क्र. सं.</td>
                  <td
                    className="font-weight-bold"
                    style={{ minWidth: "628px" }}
                  >
                    व्यहोरा
                  </td>
                  <td className="font-weight-bold" style={{ width: "160px" }}>
                    अस्तित्व ({changeIndexToNepali(totalMarks)})
                  </td>
                  <td className="font-weight-bold" style={{ width: "160px" }}>
                    निरन्तर कार्यान्वयन ({changeIndexToNepali(totalMarks2)})
                  </td>
                  <td
                    className="font-weight-bold"
                    style={{ minWidth: "250px" }}
                  >
                    कैफियत
                  </td>
                </tr>
              </thead>
              <tbody>
                {questionData.map((item) => (
                  <Fragment key={item.id}>
                    {item.type === "indicator" ? (
                      <tr className="table-bg-white text-align">
                        <td className="text-right">
                          {changeIndexToNepali(item.indicator)}
                        </td>
                        <td>{item.question}</td>
                        <Actions
                          item={item}
                          fiscal_year_id={fiscalYear}
                          ministryid={ministryid}
                          setQuestionData={setQuestionData}
                        />
                        {/* {console.log("ministryid", ministryid)} */}
                      </tr>
                    ) : (
                      <tr className="if-heading">
                        <td className="question-heading text-right">
                          {changeIndexToNepali(item.indicator)}
                        </td>
                        <td className="question-heading" colSpan={4}>
                          {item.question}
                        </td>
                      </tr>
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal
        isOpen={showConfirm}
        toggle={toogleConfirmation}
        className="delete-modal"
      >
        <ModalHeader toggle={toogleConfirmation}>
          प्रकाशित गर्नुहोस्
        </ModalHeader>
        <ModalBody>के तपाइँ निश्चित रूपमा प्रकाशित गर्न चाहनुहुन्छ?</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleSubmit()}>
            प्रकाशित गर्नुहोस्
          </Button>
          <Button color="red" onClick={toogleConfirmation}>
            रद्द गर्नुहोस्
          </Button>
        </ModalFooter>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default InternalControl;
